import React, { useState } from "react";
import "./CheckoutCard.css";
import CheckoutButton from "../CheckoutButton/CheckoutButton";

function CheckoutCard({
  food,
  quantity,
  availableQty,
  totalCartQuantity,
  onAdd,
  onRemove,
  isDisabledButton,
}) {
  const [isShaking, setIsShaking] = useState(false);

  const { title, price, category, brand } = food;

  const totalPrice = price * quantity;

  // Get max quantity config from localStorage
  const getMaxQuantityConfig = () => {
    try {
      const config = localStorage.getItem('maxQuantityConfig');
      return config ? JSON.parse(config) : { enabled: false, maxQuantity: 0 };
    } catch (error) {
      console.error('[CheckoutCard] Error parsing maxQuantityConfig:', error);
      return { enabled: false, maxQuantity: 0 };
    }
  };

  const getMaxOrderQuantityConfig = () => {
    try {
      const config = localStorage.getItem('maxOrderQuantityConfig');
      return config ? JSON.parse(config) : { enabled: false, maxOrderQuantity: 0 };
    } catch (error) {
      return { enabled: false, maxOrderQuantity: 0 };
    }
  };

  const triggerShake = () => {
    setIsShaking(true);
    setTimeout(() => {
      setIsShaking(false);
    }, 1000);
  };

  const handleIncrement = (amount) => {
    const maxQuantityConfig = getMaxQuantityConfig();
    const { enabled, maxQuantity } = maxQuantityConfig;
    const maxOrderConfig = getMaxOrderQuantityConfig();

    // Check available inventory
    if (quantity >= availableQty) {
      triggerShake();
      return;
    }

    let newAdditionalQty = amount;

    // Cap by max quantity per product
    if (enabled && maxQuantity > 0) {
      const maxAllowedForProduct = maxQuantity - quantity;
      if (newAdditionalQty > maxAllowedForProduct) {
        newAdditionalQty = maxAllowedForProduct;
      }
    }

    // Cap by max order quantity
    if (maxOrderConfig.enabled && maxOrderConfig.maxOrderQuantity > 0) {
      const orderRemaining = maxOrderConfig.maxOrderQuantity - (totalCartQuantity || 0);
      if (newAdditionalQty > orderRemaining) {
        newAdditionalQty = orderRemaining;
      }
    }

    // Cap by available inventory
    const inventoryRemaining = availableQty - quantity;
    if (newAdditionalQty > inventoryRemaining) {
      newAdditionalQty = inventoryRemaining;
    }

    if (newAdditionalQty > 0) {
      onAdd(food, newAdditionalQty);
    } else {
      triggerShake();
    }
  };

  // amount will be in negative
  const handleDecrement = (amount) => {
    let newSubtractQty = amount;
    if (quantity - amount <= 0) {
      newSubtractQty = quantity - 0;
    }
    onRemove(food, newSubtractQty);
  };

  return (
    <div className="checkout__card">
      <div className="checkout__image__container">🍼</div>

      <div className="checkout__card__title">
        <h4 className="checkout__title">
          {brand} {category} {title}{" "}
        </h4>
        <div className="checkout-btn-container">
          {quantity >= 5 ? (
            <CheckoutButton
              className="decrement-5"
              title="-5"
              type="subtract"
              onClick={() => handleDecrement(5)}
            />
          ) : (
            ""
          )}
          {quantity > 0 ? (
            <CheckoutButton
              className="decrement"
              title="-"
              type="subtract"
              onClick={() => handleDecrement(1)}
            />
          ) : (
            ""
          )}
          {quantity}
          <CheckoutButton
            className={`${isShaking ? "shake2" : ""}`}
            title={`${quantity > 0 ? "+" : "ADD"}`}
            type="add"
            onClick={() => handleIncrement(1)}
          />
          {quantity >= 5 ? (
            <CheckoutButton
              className={`increment-5 ${isShaking ? "shake2" : ""}`}
              title="+5"
              type="add"
              onClick={() => handleIncrement(5)}
            />
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="checkout__card__total">
        <span className="checkout__card__price">${totalPrice.toFixed(2)}</span>
      </div>
    </div>
  );
}

export default CheckoutCard;
